/**
 * Created by sergeiton on 14/5/17.
 */
(function () {
    'use strict';

    // @ngInject
    Services.ForterHelperService = function ForterHelperService($q, AppConfigService) {
        this.getForterToken = function getForterToken() {
            var value = "; " + document.cookie;
            var parts = value.split("; forterToken=");
            if (parts.length === 2) {
                return parts.pop().split(";").shift();
            }
            return '';
        };
    };
}());